import { Device } from "./Device"
import { Label } from "./Label"
import { Patient } from "./Patient"

export enum LabelSetType {
    NotSpecified = 0,
    UserSet = 1,
    DeviceSet = 2,
    AiSet = 3,
}

export class LabelSet {
    id: string = ""
    userId: string | null = null
    name: string = ""
    labels: Label[] = []
    deviceId: string = ""
    device: Device | null = null
    patientId: string = ""
    patient: Patient | null = null
    metadata?: Record<string, any> = {}
    type: LabelSetType = LabelSetType.NotSpecified

    constructor(init?: Partial<LabelSet>) {
        if (!init) {
            return
        }

        Object.assign(this, init)

        if (init.labels) {
            this.labels = init.labels.map(l => new Label(l))
        }

        if (init.device) {
            this.device = new Device(init.device)
        }

        if (init.patient) {
            this.patient = new Patient(init.patient)
        }
    }
}
